module.exports = __webpack_public_path__ + "static/media/initBurger.385ae813.png";